import { DocumentSubCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentSubCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getDocumentSubCategory(): Observable<DocumentSubCategoryDto[]> {
    return this.http.get<DocumentSubCategoryDto[]>(
      this.url + 'document-sub-category'
    );
  }

  createDocumentSubCategory(
    data: DocumentSubCategoryDto[]
  ): Observable<DocumentSubCategoryDto[]> {
    return this.http.post<DocumentSubCategoryDto[]>(
      this.url + 'document-sub-category',
      data
    );
  }
  getSingleDocumentSubCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'document-sub-category/' + id);
  }

  updateDocumentSubCategory(
    data: DocumentSubCategoryDto[]
  ): Observable<DocumentSubCategoryDto[]> {
    return this.http.post<DocumentSubCategoryDto[]>(
      this.url + 'document-sub-category/update',
      data
    );
  }

  deleteDocumentSubCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('document-sub-category', ids.join(', '));
    return this.http.delete(this.url + 'document-sub-category', httpOptions);
  }
}
